import { useClipboard } from '@mantine/hooks';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { memo, ReactNode } from 'react';
import { css } from 'styled-components';

interface Props {
	text: string | number;
	children: ReactNode;
	className?: string;
	iconPlacement?: 'left' | 'right';
	isIssuer?: boolean;
	contentDataTestId?: string;
}

const CopyCellText = ({
	text,
	children,
	iconPlacement = 'left',
	isIssuer = false,
	contentDataTestId,
}: Props) => {
	const clipboard = useClipboard({ timeout: 1000 });

	const icon = clipboard.copied ? (
		<IconCheck size={22} className="cap-table-copy-text-icon cap-table-copy-text-copied-icon" />
	) : (
		<IconCopy
			size={22}
			className="cap-table-copy-text-icon cap-table-copy-text-copy-icon"
			onClick={() => clipboard.copy(text)}
		/>
	);

	return (
		<div className="cap-table-copy-text">
			{iconPlacement === 'left' && icon}
			<span className={isIssuer ? 'is-issuer' : ''} data-testid={contentDataTestId}>
				{children}
			</span>
			{iconPlacement === 'right' && icon}
		</div>
	);
};

export const CapTableCopyCellTextStyles = css`
	.cap-table-copy-text {
		width: 100%;

		.cap-table-copy-text-icon {
			padding: 0.2rem;
			margin: 0 0.3rem;
			border-radius: 0.25rem;
			vertical-align: middle;
		}

		.cap-table-copy-text-copy-icon {
			display: none;

			&:hover {
				cursor: pointer;
				background-color: ${(props) => props.theme.v3.colors.gray[2]};
			}
		}

		.cap-table-copy-text-copied-icon {
			background-color: ${(props) => props.theme.v3.colors.green[2]};
		}

		&:hover {
			.cap-table-copy-text-copy-icon {
				display: inline;
			}

			span.is-issuer {
				color: ${(props) => props.theme.v3.colors.blue[6]};
				text-decoration: underline;
			}
		}
	}
`;

const Memoized = memo(CopyCellText);

export { Memoized as CopyCellText };
